import React, { useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import { buildInstanceCreatePayload, createWebHooks } from './utils';
const FASTAPI_URL = process.env.REACT_APP_API_URL;

const QRCodeDisplayV2 = () => {
    const { user_id } = useParams();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const instanceId = searchParams.get('instance');

    const [qrCode, setQrCode] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [webhookCreated, setWebhookCreated] = useState(false);

    const createInstance = async () => {
        if (!instanceId) {
            setError('Missing instance ID');
            return;
        }

        setLoading(true);
        setError('');

        try {
            await axios.delete(`${FASTAPI_URL}/api/user/${user_id}/instances`);
        } catch (e) {
            console.warn('Failed to cleanup instances:', e);
        }

        try {
            const data = buildInstanceCreatePayload(instanceId);
            const resp = await axios.post(`${FASTAPI_URL}/api/instance/create`, data, {
                headers: { 'Content-Type': 'application/json' },
            });
            if (resp.data && resp.data.qrcode) {
                setQrCode(resp.data.qrcode.base64);
            } else {
                setError('Failed to retrieve QR code.');
                setLoading(false);
                return;
            }
        } catch (err) {
            console.error('Error creating instance:', err);
            setError('Failed to create WhatsApp instance.');
            setLoading(false);
            return;
        }

        try {
            const webhookResp = await axios.get(`${FASTAPI_URL}/api/webhook/find/${encodeURIComponent(instanceId)}`);
            if (webhookResp.data === null) {
                await createWebHooks(instanceId);
            }
            setWebhookCreated(true);
        } catch (err) {
            console.error('Error fetching webhook:', err);
            setError('Failed to check/create webhook.');
            setLoading(false);
            return;
        }

        setLoading(false);
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <div style={{ color: 'red' }}>{error}</div>;

    if (!qrCode) {
        return <button onClick={createInstance}>Create WhatsApp Instance</button>;
    }

    if (webhookCreated) {
        return (
            <div>
                <img src={qrCode} alt={`WhatsApp QR Code for User ID ${user_id}`} />
            </div>
        );
    }

    return null;
};

export default QRCodeDisplayV2;
